import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CaptchaData } from '../../../modules/customer-care/models/captcha.model';
import { IpService } from '../../../modules/customer-care/services/ip.service';

@Component({
    selector: 'cop-docs-second-feedback-form',
    templateUrl: './docs-second-feedback-form.component.html',
    styleUrls: ['./docs-second-feedback-form.component.scss'],
    standalone: false
})
export class DocsSecondFeedbackFormComponent implements OnInit {

  docsSecondFeedbackForm: UntypedFormGroup = new UntypedFormGroup({});
  mainPageLoader: boolean = false;
  formId: string = "";
  topic1Label: string = "";
  topic2Label: string = "";
  p2Val: string = "";
  p3Val: string = "";
  apiFailMsg: boolean = false;
  apiSuccessMsg: boolean = false;
  hideForm: boolean = false;
  hide: boolean = false;
  msg1: boolean = false;
  msg2: boolean = false;
  msg3: boolean = false;
  isValid: boolean = false;
  emailPattern: RegExp = /[a-zA-Z0-9-.-_(\\+)]{1,}@[a-zA-Z0-9.-]{2,253}[.]{1}[a-zA-Z]{2,}/; //Avaya email pattern
  captchaToken: string = "";
  captchaSucces: boolean = false;
  topicTitle: string = "";
  topicURL: string = "";
  docTitle: string = "";
  releaseNo: string = "";
  topicPubTitle: string = "";
  topicIDURL: string = "";
  isValidatingCaptchaToken: boolean = false;
  remoteIP: string = "";
  tokenAPICallCnt: number = 0;
  dismissMsg: string = "";

  constructor(
    private ds: DataService,
    private router: ActivatedRoute,
    private translateService: TranslateService,
    private snackBar: MatSnackBar,
    private ipService: IpService
  ) { }

  ngOnInit() {
    this.mainPageLoader = true;
    this.setLocalizationText();
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.remoteIP = res.ip;
    });

    setTimeout(() => {
      // this.captchaKey = environment.captchaKey;
      this.docsSecondFeedbackForm = new UntypedFormGroup({
        topic1: new UntypedFormControl("", Validators.required),
        topic2: new UntypedFormControl("", Validators.required),
        options: new UntypedFormControl("", Validators.required),
        name: new UntypedFormControl(""),
        email: new UntypedFormControl(""),
        confirm_email: new UntypedFormControl(""),
        description: new UntypedFormControl("")
      });

      this.router.queryParams.subscribe(params => {
        if (params.formId) {
          this.formId = params.formId;
          this.hideForm = false;
        } else
          this.hideForm = true;

        if (params.p1) {
          if (params.p1 == "S1") {
            this.topic1Label = this.topicTitle;
            this.topic2Label = this.topicURL;
          } else if (params.p1 == "S2") {
            this.topic1Label = this.docTitle;
            this.topic2Label = this.topicTitle;
          } else {
            this.topic1Label = this.docTitle;
            this.topic2Label = this.releaseNo;
          }
        } else {
          this.topic1Label = this.topicPubTitle;
          this.topic2Label = this.topicIDURL;
        }
        if (params.p2)
          this.p2Val = params.p2;
        if (params.p3)
          this.p3Val = params.p3;
      });

      setTimeout(() => {
        this.docsSecondFeedbackForm.setValue({ topic1: this.p2Val, topic2: this.p3Val, options: "", name: "", email: "", confirm_email: "", description: "" });
        if (this.p2Val)
          this.docsSecondFeedbackForm.get("topic1")?.disable();
        if (this.p3Val)
          this.docsSecondFeedbackForm.get("topic2")?.disable();
        this.mainPageLoader = false;
      }, 2500);
    }, 1500);
  }

  onSubmitForm() {
    // console.log("user form",this.docsSecondFeedbackForm);
    // console.log("captcha", this.captchaSucces);
    if (this.docsSecondFeedbackForm.valid && this.captchaSucces) {
      this.mainPageLoader = true;
      let payload = {
        "formId": this.formId,
        "source": "Onecare",
        "questions": [
          { "qname": this.topic1Label, "qvalue": this.docsSecondFeedbackForm.getRawValue().topic1 ? this.docsSecondFeedbackForm.getRawValue().topic1 : "", "qcontext": "summary" }
        ],
        "additionalinformation": [
          { "name": this.topic2Label, "value": this.docsSecondFeedbackForm.getRawValue().topic2 ? this.docsSecondFeedbackForm.getRawValue().topic2 : "" },
          { "name": "name", "value": this.docsSecondFeedbackForm.value.name },
          { "name": "email", "value": this.docsSecondFeedbackForm.value.email },
          { "name": "confirm_email", "value": this.docsSecondFeedbackForm.value.confirm_email },
          { "name": "description", "value": this.docsSecondFeedbackForm.value.description }
        ]
      };

      this.ds.getITSSToken().subscribe((res: any) => {
        if(res && res.token) {
          this.ds.submitJiraTicket(payload, res.token).subscribe((data: any) => {
            if (data.returnCode === 0) {
              this.apiFailMsg = false;
              this.apiSuccessMsg = true;
            } else {
              this.apiFailMsg = true;
              this.apiSuccessMsg = false;
            }
            this.mainPageLoader = false;
          }, (error) => {
            this.mainPageLoader = false;
            this.apiFailMsg = true;
            this.apiSuccessMsg = false;
            console.error("Form can not submit...", error);
          });
        } else {
          this.mainPageLoader = false;
          this.apiFailMsg = true;
          this.apiSuccessMsg = false;
          console.error("Form can not submit, token fetch failed...", res);
        }
      });
    } else {
      alert("Please fill all the required fields.");
      return;
    }
  }

  checkEmail() {
    let val1 = this.docsSecondFeedbackForm.get("email")?.value;
    let val2 = this.docsSecondFeedbackForm.get("confirm_email")?.value;
    if (this.docsSecondFeedbackForm.get("email")?.touched && this.docsSecondFeedbackForm.get("confirm_email")?.touched) {
      if (val1 && val2 && val1.trim() == val2.trim())
        this.isValid = true;
      else
        this.isValid = false;
    }
  }

  setLocalizationText() {
    this.translateService.get('topicTitle').subscribe((res: string) => {
      this.topicTitle = res;
    });
    this.translateService.get('topicURL').subscribe((res: string) => {
      this.topicURL = res;
    });
    this.translateService.get('docTitle').subscribe((res: string) => {
      this.docTitle = res;
    });
    this.translateService.get('releaseNo').subscribe((res: string) => {
      this.releaseNo = res;
    });
    this.translateService.get('topicPubTitle').subscribe((res: string) => {
      this.topicPubTitle = res;
    });
    this.translateService.get('topicIDURL').subscribe((res: string) => {
      this.topicIDURL = res;
    });
    this.translateService.get('dismissMessage').subscribe((res: string) => {
      this.dismissMsg = res;
    });
  }

  userSelectOption() {
    let value = this.docsSecondFeedbackForm.controls["options"].value;
    this.msg1 = this.msg2 = this.msg3 = false;
    this.docsSecondFeedbackForm.get("name")?.reset();
    this.docsSecondFeedbackForm.get("email")?.reset();
    this.docsSecondFeedbackForm.get("confirm_email")?.reset();
    this.docsSecondFeedbackForm.get("description")?.reset();
    if (["The content is incorrect", "The topic or manual is missing information", "I cannot find the information I am looking for", "I found a broken link", "Other"].includes(value)) {
      this.hide = true;
      this.isValid = false;
      this.docsSecondFeedbackForm.get("name")?.setValidators([Validators.required]);
      this.docsSecondFeedbackForm.get("email")?.setValidators([Validators.required, Validators.pattern(this.emailPattern)]);
      this.docsSecondFeedbackForm.get("confirm_email")?.setValidators([Validators.required, Validators.pattern(this.emailPattern)]);
      this.docsSecondFeedbackForm.get("description")?.setValidators([Validators.required]);
    } else {
      this.hide = false;
      this.isValid = true;
      this.docsSecondFeedbackForm.get("name")?.clearValidators();
      this.docsSecondFeedbackForm.get("email")?.clearValidators();
      this.docsSecondFeedbackForm.get("confirm_email")?.clearValidators();
      this.docsSecondFeedbackForm.get("description")?.clearValidators();
      if (value == "I need help with a password or logon")
        this.msg1 = true;
      else if (value == "I have a question about the product")
        this.msg2 = true;
      else if (value == "The product is not working as expected/documented")
        this.msg3 = true;
    }
    this.docsSecondFeedbackForm.get("name")?.updateValueAndValidity();
    this.docsSecondFeedbackForm.get("email")?.updateValueAndValidity();
    this.docsSecondFeedbackForm.get("confirm_email")?.updateValueAndValidity();
    this.docsSecondFeedbackForm.get("description")?.updateValueAndValidity();
  }

  handleCaptcha(data: CaptchaData) {
    this.captchaSucces = data.captchaLoading;
    this.tokenAPICallCnt = 0;
    if (data.token) {
      this.captchaToken = data.token;
      this.isValidatingCaptchaToken = true;
      this.ds.getITSSToken().subscribe((res: any) => {
        if(res && res.token) {
          this.ds.publicPostData("validateToken", { token: data.token, remoteip: this.remoteIP }, res.token).subscribe((captchaRes: any) => {
            this.isValidatingCaptchaToken = false;
            this.tokenAPICallCnt++;
            if (captchaRes.success)
              this.captchaSucces = true;
            else {
              this.captchaSucces = false;
              this.snackBar.open("Captcha token verification failed. Please reload the page.", this.dismissMsg);
            }
          }, (err: any) => {
            this.tokenAPICallCnt++;
            this.snackBar.open("Captcha token verification failed. Please reload the page.", this.dismissMsg);
            console.error("Error while verifying captcha token", err);
            this.isValidatingCaptchaToken = false;
            this.captchaSucces = false;
          });
        } else {
          this.tokenAPICallCnt++;
          this.snackBar.open("Captcha token verification failed. Please reload the page.", this.dismissMsg);
          console.error("Error while verifying captcha token, itss token fetch failed", res);
          this.isValidatingCaptchaToken = false;
          this.captchaSucces = false;
        }
      });
    } else {
      this.tokenAPICallCnt++;
      this.isValidatingCaptchaToken = false;
      this.captchaSucces = false;
      return;
    }
  }
}
